import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FiMinus, FiPlus, FiTrash } from 'react-icons/fi';
import { Image } from '..';

import { addAmount, subAmount, removeFromBasket } from '../../../support/store/BasketReducer';

import styles from './BasketCard.module.css';

import { measureTypeForm, leadTimeToText } from '../../../support/services/formatter';

function BasketCard({ offer = {}, basketItem = {}, dispatch }) {
  const {
    name,
    availableStock,
    value,
    type,
    measureType,
    measureQuantity,
    imagesPaths,
    leadTime,
  } = offer;

  const [basketAmount, setBasketAmount] = useState(basketItem.amount);

  const imageUrl = imagesPaths[imagesPaths.length - 1];

  function addBasketItemAmount() {
    if (basketAmount >= offer.availableStock && type !== 'scheduled_delivery') return;

    setBasketAmount(basketAmount + 1);
    dispatch(addAmount({ id: offer.id }));
  }

  function subBasketItemAmount() {
    if (basketAmount === 1) {
      return removeItemFromBasket();
    }

    setBasketAmount(basketAmount - 1);
    dispatch(subAmount({ id: offer.id }));
  }

  function removeItemFromBasket() {
    if (window.confirm('Você deseja realmente remover da cesta?')) {
      dispatch(removeFromBasket({ id: offer.id }));
    }
  }

  return (
    <div className={styles.card}>
      <div className={styles.divisory}>
        <div className={styles.divisoryLine} />
      </div>

      <div className={styles.cardInfo}>
        <section className={styles.cardImage}>
          <Image src={imageUrl} alt={`Foto do produto ${name}`} />
        </section>

        <section className={styles.offerInfo}>
          <div>
            <h3>{name}</h3>
            <p>
              {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)}
              {` (${measureQuantity} ${measureTypeForm(measureType, measureQuantity)})`}
            </p>
            <p className={styles.availableAmount}>
              {type === 'scheduled_delivery'
                ? `${leadTimeToText(leadTime)} para praparar`
                : `${availableStock} disponíveis`}
            </p>
          </div>

          <button type="button" onClick={removeItemFromBasket}>
            <FiTrash size={15} />
            <p>Remover da cesta</p>
          </button>
        </section>
      </div>

      <section className={styles.summary}>
        <h2 className={styles.itemPrice}>
          {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(basketAmount * value)}
        </h2>
        <p>{`${measureQuantity * basketAmount} ${measureTypeForm(measureType, measureQuantity)}`}</p>

        <div className={styles.amountInput}>
          <FiPlus className={styles.amountIcon} onClick={addBasketItemAmount} size={32} color="#222" strokeWidth="0.5" />
          <input type="number" disabled value={basketAmount} />
          <FiMinus className={styles.amountIcon} onClick={subBasketItemAmount} size={32} color="#222" strokeWidth="0.5" />
        </div>
      </section>
    </div>
  );
}

BasketCard.propTypes = {
  offer: PropTypes.object.isRequired,
  basketItem: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
};

export default connect()(BasketCard);
